import ColumnsDrawerTasksDelayed from "@/columns/ColumnsDrawers";
import Vue from "vue";
const vue = new Vue();

export const getDelayedTasks = async function (thisL, directionId) {
  //console.log(thisL.currentUser.EmployeeId);
  let RolId = thisL.currentUser.Roles.filter((r) => r.Id === 37).map(
    (x) => x.Id
  )[0];
  let isSupervisor = thisL.currentUser.IsSupervisor;
  let condicion = "";
  if (RolId === 37) {
    condicion = "ceo"; //para que el CEO vea todas las tareas retrasadas
  } else if (isSupervisor === true) {
    condicion = "sup"; //para que el supervisor vea todas las tareas retrasadas dentro de su Direccion
  } else {
    condicion = "res"; //para que el responsable vea solo las tareas retrasadas a las que se le asignó
  }

  let tableData = [];
  await vue.$http
    .get("/api/MessageApi/GetDelayedTasks", {
      timeout: 3 * 60 * 1000,
      params: {
        CompanyCode: thisL.currentUser.CompanySelected,
        EmployeeId: thisL.currentUser.EmployeeId,
        Direccionid: directionId, //thisL.currentUser.DireccionID,
        Rol: condicion,
        OptionObjective: 1
      }
    })
    .then((resp) => {
      //tableData = resp.data[3].Task;
      tableData = resp.data.find((r) => r.Title === "Tareas Retrasadas").Task;
    });
  return tableData;
};
export const DelayedTaskColumns = ColumnsDrawerTasksDelayed;

export const actions = (thiss) => [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-task-view-others",
    condition: (row) => row.Types != "task"
  },
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-task-view",
    condition: (row) => row.Types == "task"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "view-task-edit",
    condition: (row) => row.Types == "task" && !row.PercentageProsposal
  },
  {
    icon: "el-icon-check",
    label: "Aprobar",
    command: "approve-task-percent",
    condition: (row) => row.PercentageProsposal
  },
  {
    icon: "el-icon-circle-close",
    label: "Cancelar",
    command: "Cancel-task",
    condition: (row) =>
      row.Types == "InternalRequest" &&
      //this.currentUser.Roles.filter((r) => {  return r.Id === 37  }).length > 0
      this.currentUser.Roles.some((r) => {
        return r.Id === 37;
      })
  },
  {
    icon: "el-icon-delete-solid",
    label: "Eliminar",
    command: "delete-task",
    condition: (row) => {
      let isValid = thiss.currentUser.EmployeeId === row.CreatedBy;
      return isValid;
    }
  }
];

export const ActionTaskHandler = async function (action) {
  //console.log("imprimelo ahi el action", action)
  let rowObjective;
  if (action.row.ObjetiveID) {
    await vue.$http
      .get("/api/CMI/Objetives/getGanttObjetiveByID", {
        params: {
          Id: action.row.ObjetiveID
        }
      })
      .then((response) => {
        rowObjective = response.data;
      });
  }

  //this.taskDrawer = true;
  let rowData = {
    task: action.row,
    objective: rowObjective
  };
  switch (action.command) {
    case "view-task-view-others":
      //console.log("prueba d ebaltriles")
      this.$message({
        type: "warning",
        message:
          "Esta acción todavía no está habilitada. Disculpe los inconvenientes."
      });
      break;
    case "view-task-view":
      //console.log("hey")
      action.refs.taskFormDrawer.show(rowData, true, false, false);
      //console.log("viendo detalle")
      break;

    case "view-task-edit":
      action.refs.taskFormDrawer.show(rowData, false, false, true);
      //console.log("hola desde delayedtask");
      action.refs.taskFormDrawer.IsNewTask;
      break;

    case "Cancel-task":
      this.RowData = action;
      this.StatusToChange = 4;
      //this.CancelRequest(action, 4);
      this.centerDialogVisible = true;
      break;
  }
  return action;
};
